import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './article-page-news-intro.component.scss';
var ArticlePageNewsIntro = /** @class */ (function (_super) {
    tslib_1.__extends(ArticlePageNewsIntro, _super);
    function ArticlePageNewsIntro(element) {
        return _super.call(this, element) || this;
    }
    ArticlePageNewsIntro.prototype.init = function () { };
    ArticlePageNewsIntro.prototype.bindEvents = function () { };
    return ArticlePageNewsIntro;
}(Base));
export { ArticlePageNewsIntro };



//////////////////
// WEBPACK FOOTER
// ./components/article-page-news-intro/article-page-news-intro.component.ts
// module id = 105
// module chunks = 0